import { useEffect } from 'react'
import { Link } from 'react-router-dom';
import FooterContact from '../../../component/FooterContact';
import HomeVideo2 from '../../../assets/images/banner/banner-1.mp4';

export default function DigitalWorkforce() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Hero */}
            <section className="pad60 box-shadow innertopbanner" style={{ position: 'relative', overflow: 'hidden' }}>
                <div className="overlay-top-left"></div>
                <div className="container">
                    <div className="row align-items-center height100">
                        <div className="col-lg-7 col-md-12">
                            <div className="banner-caption">
                                <div itemScope itemType="http://schema.org/BreadcrumbList" className="breadcrumbs">
                                    <ul>
                                        <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                                            <Link to="/"><span itemProp="name">Home</span></Link>
                                            <meta itemProp="position" content="1" />
                                        </li>
                                        <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                                            <i className="icofont-thin-right"></i>
                                            <span itemProp="name">Digital Workforce</span>
                                            <meta itemProp="position" content="2" />
                                        </li>
                                    </ul>
                                </div>
                                <div className="prod-section-label">Digital Workforce</div>
                                <h1 className="prod-hero-title">Digital Workforce, <span>Wherever</span></h1>
                                <p>Facilitate secure remote work with an integrated end-to-end solution that combines ZTNA, IAM, and VDI — enabling your employees to be productive and secure from any location.</p>
                                <div className="button_services mt-4">
                                    <Link to="/contact"><button className="prod-cta-btn">Contact Us &nbsp;<i className="fa fa-arrow-right"></i></button></Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-12">
                            <div className="banner-mobiles text-center">
                                <img src={require('../../../assets/images/services/products/data-bg-transparant.webp')} alt="Digital Workforce" />
                            </div>
                        </div>
                    </div>
                </div>
                <video autoPlay loop muted style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: -1 }}>
                    <source src={HomeVideo2} type="video/mp4" />
                </video>
            </section>

            {/* Stats */}
            <section style={{ background: '#0a0a0a', padding: '0 0 20px' }}>
                <div className="container">
                    <div className="prod-stats-row">
                        <div className="prod-stat-item">
                            <div className="prod-stat-number">ZTNA</div>
                            <div className="prod-stat-label">Zero Trust Network Access</div>
                        </div>
                        <div className="prod-stat-item">
                            <div className="prod-stat-number">VDI</div>
                            <div className="prod-stat-label">Virtual Desktop Infrastructure</div>
                        </div>
                        <div className="prod-stat-item">
                            <div className="prod-stat-number">IAM</div>
                            <div className="prod-stat-label">Identity & Access Management</div>
                        </div>
                        <div className="prod-stat-item">
                            <div className="prod-stat-number">MFA</div>
                            <div className="prod-stat-label">Multi-Factor Authentication</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Overview */}
            <section className="prod-info-section" style={{ background: '#0a0a0a' }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/services/workspace/digital-workplace.webp')} alt="Digital Workforce" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="prod-info-content">
                                <div className="prod-section-label">Overview</div>
                                <h2>Secure, Flexible Digital Workspace for Everyone</h2>
                                <p>Cloud Mind is committed to delivering a secure, flexible, and all-encompassing digital workspace solution that enables employees to work from anywhere. Organizations globally are seeking ways to transition from traditional hardware-based IT to fully software-defined solutions.</p>
                                <p>Cloud Mind Digital Workspace offers a comprehensive, zero-trust-based end-user computing solution — ensuring secure, instant access to business applications from any location, device, or network. Often deployable in just a few days.</p>
                                <Link to="/contact" className="prod-cta-btn" style={{ marginTop: '12px', display: 'inline-flex' }}>
                                    Talk to Experts <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* 6 Features */}
            <section className="prod-highlight-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="prod-section-label" style={{ margin: '0 auto 16px' }}>Features</div>
                        <h2 className="prod-section-title">Platform <span>Features</span></h2>
                        <p className="prod-section-sub" style={{ margin: '0 auto' }}>A comprehensive suite of integrated security and productivity capabilities</p>
                    </div>
                    <div className="prod-features-grid" style={{ paddingTop: 0 }}>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon">
                                <img src={require('../../../assets/images/services/workspace/icons-1.png')} alt="" style={{ width: 28, height: 28, filter: 'brightness(0) invert(1)' }} />
                            </div>
                            <h4>Zero Trust-Based Access</h4>
                            <p>Implement ZTNA at the application layer to maximize network security, making CLOUD MIND Digital Workspace the ideal solution for secure remote work from any location.</p>
                            <div className="prod-feature-number">01</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon">
                                <img src={require('../../../assets/images/services/workspace/icons-2.png')} alt="" style={{ width: 28, height: 28, filter: 'brightness(0) invert(1)' }} />
                            </div>
                            <h4>Data Leakage Prevention</h4>
                            <p>Block printing, screen recording, copy-paste, and USB storage. Browser isolation regulates internet access during work, ensuring a secure and controlled digital workspace.</p>
                            <div className="prod-feature-number">02</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon">
                                <img src={require('../../../assets/images/services/workspace/icons-3.png')} alt="" style={{ width: 28, height: 28, filter: 'brightness(0) invert(1)' }} />
                            </div>
                            <h4>Device Entry Control</h4>
                            <p>Endpoint scanning based on antivirus status, firewall configuration, OS patch updates, and browser versions — access granted only from compliant and secure devices.</p>
                            <div className="prod-feature-number">03</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon">
                                <img src={require('../../../assets/images/services/workspace/icons-4.png')} alt="" style={{ width: 28, height: 28, filter: 'brightness(0) invert(1)' }} />
                            </div>
                            <h4>Multi-Factor Authentication</h4>
                            <p>Robust authentication through SMS, email, mobile apps, PC software, or biometrics — significantly enhancing the security of the workspace solution at every access point.</p>
                            <div className="prod-feature-number">04</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon">
                                <img src={require('../../../assets/images/services/workspace/icons-5.png')} alt="" style={{ width: 28, height: 28, filter: 'brightness(0) invert(1)' }} />
                            </div>
                            <h4>Contextual Access</h4>
                            <p>Ensure corporate assets are accessible only to authorized users in the right context. Implement access control based on location, time, and device health at all levels.</p>
                            <div className="prod-feature-number">05</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon">
                                <img src={require('../../../assets/images/services/workspace/icons-6.png')} alt="" style={{ width: 28, height: 28, filter: 'brightness(0) invert(1)' }} />
                            </div>
                            <h4>User Productivity Monitoring</h4>
                            <p>Track productivity by monitoring log-on and log-off times, along with duration spent on various activities and applications — providing valuable business insights.</p>
                            <div className="prod-feature-number">06</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Why Choose */}
            <section className="prod-dark-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="prod-section-label" style={{ margin: '0 auto 16px' }}>Why Choose Us</div>
                        <h2 className="prod-section-title">Why Cloud Mind's <span>Digital Workspace?</span></h2>
                        <p className="prod-section-sub" style={{ margin: '0 auto' }}>A comprehensive virtual workspace solution designed to boost productivity and security in the modern workplace</p>
                    </div>
                    <div className="prod-numbered-list">
                        <div className="prod-step-item">
                            <span className="prod-step-num">01</span>
                            <div>
                                <h4>Integrated MFA with Biometric Authentication</h4>
                                <p>Guarantees that the virtual workspace remains secure — no matter where employees connect from, using the strongest available authentication methods.</p>
                            </div>
                        </div>
                        <div className="prod-step-item">
                            <span className="prod-step-num">02</span>
                            <div>
                                <h4>Zero Trust Model-Based Access Gateway</h4>
                                <p>Provides robust protection, enabling secure work from anywhere — trusting no user or device by default, verifying everything before granting access.</p>
                            </div>
                        </div>
                        <div className="prod-step-item">
                            <span className="prod-step-num">03</span>
                            <div>
                                <h4>Strict Device Entry Control</h4>
                                <p>Access is granted only from authorized and compliant devices, strengthening endpoint security and reducing the risk of compromised endpoints accessing sensitive data.</p>
                            </div>
                        </div>
                        <div className="prod-step-item">
                            <span className="prod-step-num">04</span>
                            <div>
                                <h4>Sandbox Computing &amp; App Containerization</h4>
                                <p>Creates a secure environment for running critical applications — isolating them from potential threats and ensuring data integrity across all sessions.</p>
                            </div>
                        </div>
                        <div className="prod-step-item">
                            <span className="prod-step-num">05</span>
                            <div>
                                <h4>Lower Total Cost of Ownership (TCO)</h4>
                                <p>Access maximum features at a lower cost — eliminating the need to manage multiple point solutions or vendors with one comprehensive platform.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section style={{ background: '#0a0a0a', padding: '0 0 80px' }}>
                <div className="container">
                    <div className="prod-cta-banner">
                        <div>
                            <h3>Enable Your Digital Workforce Today</h3>
                            <p>Deploy a secure, flexible digital workspace that empowers your people to work from anywhere — without compromising security.</p>
                        </div>
                        <Link to="/contact" className="prod-cta-btn">
                            Get Started <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                        </Link>
                    </div>
                </div>
            </section>

            <FooterContact />
        </>
    )
}
